// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableTitle {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.button-container {\n\n  margin-top: 30px;\n  float: right;\n}\n.table-container {\n  max-height: 400px;\n  overflow-y: auto;\n}\n.table-detail {\n  margin-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
